'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React from 'react';
type Props = {
    csTitle: string;
    para: string;
    url: any;
    thumbnail: any;
    alt: any;
};
const CaseStudyItem: React.FC<Props> = ({ csTitle, para, url, thumbnail, alt }) => {
    const router = useRouter();
    return (
        <div className="md:col-span-1">

            <div className="card h-full rounded-10 case-study-slider dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid">
                <div className="card-body flex justify-between flex-wrap lg:gap-0 gap-3">
                    <div className="card-description flex flex-col justify-between lg:w-3/6 w-full gap-2.5">
                        <div>
                            <p className="card-title mb-2.5 fs-lg fw-700 text-textcolor dark:text-white" onClick={() => router.push(url)}>{csTitle}</p>
                            <p className="card-text card-text-des fs-md fw-400">{para}</p>
                        </div>
                        <div>
                            <Link href={`${url}`} className="btn btn-primary ">
                                Read Case Study
                            </Link>
                        </div>
                    </div>
                    <div className="lg:w-3/6 w-full flex justify-center">
                    <Image
                            src={`${thumbnail}`}
                            alt={alt}
                            title={alt}
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'cover',
                                objectPosition: 'center',
                                backgroundColor: 'transparent',
                            }}
                            className="img-fluid case-study-img"
                            height={400}
                            width={630}
                            loading="lazy"
                        />
                        
                    </div>
                </div>
            </div>

            {/* <div
                className="card cs-card relative flex flex-col min-w-0 rounded-10 break-words border-0 bg-white dark:bg-black border-1 border-gray-300 h-full"
                data-aos="fade-up"
                data-aos-duration={1000}
                data-aos-delay={300}
            >
                <HoverVideoPlayer
                    videoSrc={`${videoUrl}`}
                    overlayTransitionDuration={50}
                    className="rounded-t-10 bg-white cursor-pointer"
                    onClick={() => {
                        router.push(url);
                    }}
                    pausedOverlay={
                        <Image
                            src={`${thumbnail}`}
                            alt={alt}
                            title={alt}
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'cover',
                                objectPosition: 'center',
                                backgroundColor: 'transparent',
                            }}
                            width="400"
                            height="351"
                            loading="lazy"
                        />
                    }
                    videoClassName="cs-video"
                    restartOnPaused
                />
                <div className="card-body flex-auto p-5 lg:p-6 !h-auto flex flex-col">
                    <h3 className="card-title mb-10px cursor-pointer" onClick={() => router.push(url)}>
                        {csTitle}
                    </h3>
                    <p className="card-text mb-5 fs-md">{para}</p>
                    {isButton ? (
                        <div className="mt-auto">
                            <Link href={`${url}`} className="btn btn-primary ">
                                Read Case Study
                            </Link>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div> */}
        </div>
    );
};
export default CaseStudyItem;
